import { render, staticRenderFns } from "./SecondAnniversary.vue?vue&type=template&id=effc4c20&"
import script from "./SecondAnniversary.vue?vue&type=script&lang=js&"
export * from "./SecondAnniversary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports